import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AuthFacade } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.facade'
import { AccountDetailsFormConfig } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.models'
import { SelectedProfileFacade } from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.facade'
import { ProfileEntity } from 'libs/gb-front/selected-profile/data-access/src/lib/+state/selected-profile.models'
import { GbFrontDialogService } from 'libs/gb-front/shared/util/src/lib/gb-front-dialog-service/gb-front-dialog.service'

@Component({
  selector: 'gb-complete-profile-dialog',
  templateUrl: './gb-complete-profile-dialog.component.html',
  styleUrls: ['./gb-complete-profile-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbCompleteProfileDialogComponent {
  isVolunteer$ = this.authFacade.isVolunteer$
  selectedProfile$ = this.selectedProfileFacade.selectedProfile$

  constructor(
    private authFacade: AuthFacade,
    private selectedProfileFacade: SelectedProfileFacade,
    private gbFrontDialogService: GbFrontDialogService,
    @Inject(MAT_DIALOG_DATA) public data?: AccountDetailsFormConfig,
  ) {}

  getFormConfig(profile?: ProfileEntity | null): AccountDetailsFormConfig {
    return {
      showPreferredContact: false,
      showCancel: true,
      showSkip: false,
      submitTranslateKey: 'ACCOUNT.COMPLETE_ACCOUNT_DIALOG.SUBMIT',
      nameEditable: !profile?.first_name || !profile?.last_name,
      ...this.data,
    }
  }

  closeDialog(): void {
    this.gbFrontDialogService.closeDialog(GbCompleteProfileDialogComponent, false)
  }
}
